<template>
  <div class="option__box">
    <div class="options__item">
      <div
        v-for="(option, idx) in itemList"
        class="option"
        :class="{
          option__active:
            (getDeliveryOptions.item[option.value].on &&
              getDeliveryOptions.item[option.value].number > 0) ||
            (option.value === 'etc' &&
              getDeliveryOptions.item[option.value].on),
          etc: option.value === 'etc'
        }"
        @click="handleEtc(option.value)"
      >
        <div class="option__description">
          <img :src="option.img" />
          <div class="option__title">
            <div>{{ option.title }}</div>
            <div class="option__title--sub" v-if="option.description">
              {{ option.description }}
            </div>
          </div>
        </div>
        <div v-if="option.value !== 'etc'" class="count">
          <img
            src="@/assets/img/order/minus.svg"
            class="count__minus"
            @click="handleCount(option.value, 'minus')"
          />
          <div
            class="count__value"
            :class="{
              'count__value--active':
                getDeliveryOptions.item[option.value].on &&
                getDeliveryOptions.item[option.value].number > 0
            }"
          >
            {{ getDeliveryOptions.item[option.value].number }}
          </div>
          <img
            src="@/assets/img/order/plus.svg"
            class="count__plus"
            @click="handleCount(option.value, 'plus')"
          />
        </div>
      </div>
    </div>
    <input
      class="etc-input"
      :class="{ 'etc-input__error': !isValidateEtc }"
      v-if="getDeliveryOptions.item.etc.on"
      type="text"
      v-model="getDeliveryOptions.item.etc.content"
      @focusout="checkValidate()"
      v-focus
      @input="updateItemEtc(true, $event.target.value), checkValidate()"
      placeholder="(필수) 물품에 대해 상세하게 입력해 주세요"
      maxlength="200"
    />
  </div>
</template>
<script>
import mixinOrder from "@/mixins/mixinOrder";
export default {
  mixins: [mixinOrder],
  data() {
    return {
      etcItemValidate: true,
      itemList: [
        {
          title: "서류",
          value: "document",
          img: require("@/assets/img/order/document.png")
        },
        {
          title: "소박스",
          description: "A4박스",
          value: "smallBox",
          img: require("@/assets/img/order/small_box.png")
        },
        {
          title: "대박스",
          description: "사과박스",
          value: "bigBox",
          img: require("@/assets/img/order/big_box.png")
        },
        {
          title: "기타",
          description: "꽃, 케잌 등",
          count: 0,
          value: "etc",
          img: require("@/assets/img/order/etc.png")
        }
      ]
    };
  },
  computed: {
    isValidateEtc() {
      return this.etcItemValidate;
    }
  },
  methods: {
    checkValidate() {
      if (this.getDeliveryOptions.item["etc"].content !== null) {
        this.etcItemValidate = true;
      } else {
        this.etcItemValidate = false;
      }
    },
    handleCount(key, method) {
      let number = this.getDeliveryOptions.item[key].number;
      if (method === "plus") {
        number = number + 1;
      } else {
        if (this.getDeliveryOptions.item[key].number > 0) {
          number = number - 1;
        }
      }
      this.updateItem(key, number, number > 0);
    },

    handleEtc(key) {
      if (key !== "etc") return;
      this.updateItemEtc(!this.getDeliveryOptions.item["etc"].on, null);
    }
  }
};
</script>
<style src="@/assets/css/newGlobal.css" scoped></style>
<style scoped>
.option {
  box-sizing: border-box;
  background-color: var(--gray-100);
  border: 1.5px solid transparent;
  color: var(--gray-700);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 12px 12px 12px;
  border-radius: 16px;
  height: 132px;
  transition-duration: 0.3s;
}

.options__item {
  display: grid;
  gap: 8px;
  margin-bottom: 20px;
}

.etc {
  cursor: pointer;
}

.option__etc {
  cursor: pointer;
}

.item-invalid {
  color: var(--red-300);
}

.option__active {
  transition-duration: 0.3s;
  box-sizing: border-box;
  border: 1.5px solid rgba(46, 163, 255, 0.6) !important;
  box-shadow: 0px 8px 16px -4px rgba(63, 83, 107, 0.08);
  background-color: var(--primary-100) !important;
  color: var(--primary-400) !important;
}

.option__description {
  display: flex;
  width: max-content;
  margin-bottom: 8px;
}

.option__title {
  color: var(--gray-700);
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 8px;
  transition-duration: 0.3s;
}

.option__active .option__title {
  transition-duration: 0.3s;
  color: var(--primary-400);
}

.option__title--sub {
  color: var(--gray-400);
  font-weight: 400;
  font-size: 13px;
  line-height: 22px;
}

.count {
  display: flex;
  justify-content: space-between;
  background-color: var(--white);
  border-radius: 12px;
  padding: 8px;
}
.etc:hover {
  background-color: var(--gray-200);
  border: 1px solid var(--gray-200);
  transition-duration: 0.3s;
}
.count img {
  cursor: pointer;
  border-radius: 99px;
}

.count img:hover {
  background-color: var(--gray-200);
  cursor: pointer;
  transition-duration: 0.3s;
}

.count__value {
  color: var(--gray-400);
  font-weight: 500;
  line-height: 24px;
  font-size: 16px;
}

.count__value--active {
  color: var(--primary-400);
}

.etc-input {
  border: 1px solid var(--primary-200);
  background-color: var(--primary-100);
}

.etc-input:focus {
  border: 1px solid var(--primary-200) !important;
  transition-duration: 0.3s;
}

.etc-input__error {
  background-color: var(--red-100);
  border: 1px solid var(--red-200);
}

.etc-input__error:focus {
  border: 1px solid var(--red-200) !important;
  transition-duration: 0.3s;
}

.option__description img {
  width: 52px;
  height: 52px;
}

@media all and (min-width: 1024px) {
  .options__item {
    grid-template-rows: 1fr;
    grid-template-columns: repeat(4, 1fr);
  }
}
@media all and (max-width: 1023px) {
  .options__item {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
}
</style>
